import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export const BeforeAfterSlider = ({ before, after, altBefore, altAfter, title, category }) => {
  const ref = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);

  const update = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    setPos(Math.min(94, Math.max(6, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <figure className="group" data-testid={`before-after-${title?.toLowerCase().replace(/\s+/g, "-")}`}>
      <div
        ref={ref}
        role="slider"
        tabIndex={0}
        aria-label={`Before and after comparison: ${title}`}
        aria-valuenow={Math.round(pos)}
        aria-valuemin={0}
        aria-valuemax={100}
        className="relative aspect-[4/5] cursor-ew-resize select-none overflow-hidden rounded-3xl border border-slate-200 bg-slate-100 shadow-sm [touch-action:pan-y]"
        onPointerDown={(e) => { dragging.current = true; ref.current.setPointerCapture(e.pointerId); update(e.clientX); }}
        onPointerMove={(e) => { if (dragging.current) update(e.clientX); }}
        onPointerUp={() => { dragging.current = false; }}
        onPointerCancel={() => { dragging.current = false; }}
        onKeyDown={(e) => {
          if (e.key === "ArrowLeft") setPos((p) => Math.max(6, p - 5));
          if (e.key === "ArrowRight") setPos((p) => Math.min(94, p + 5));
        }}
      >
        <img src={after} alt={altAfter} loading="lazy" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
        <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={before} alt={altBefore} loading="lazy" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
        </div>
        <span className="absolute left-4 top-4 rounded-full bg-brand-ink/70 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-white backdrop-blur-sm">Before</span>
        <span className="absolute right-4 top-4 rounded-full bg-brand-teal px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-white">After</span>
        <div className="absolute inset-y-0" style={{ left: `${pos}%` }} aria-hidden="true">
          <div className="absolute inset-y-0 -ml-px w-0.5 bg-white shadow-[0_0_12px_rgba(0,0,0,0.4)]" />
          <div className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border-4 border-white bg-brand-teal p-2.5 text-white shadow-xl transition-transform duration-200 group-hover:scale-110">
            <ChevronsLeftRight className="h-4 w-4" />
          </div>
        </div>
      </div>
      <figcaption className="mt-4 flex items-baseline justify-between px-1">
        <span className="font-display text-lg font-bold text-brand-ink">{title}</span>
        <span className="text-xs font-semibold uppercase tracking-widest text-brand-teal">{category}</span>
      </figcaption>
    </figure>
  );
};
